/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ActionContext } from "vuex";

interface PageMeta {
  title?: string;
  description?: string;
  additional_title?: string;
  text_field?: string;
  [k: string]: any;
}
interface PageMetaState {
  meta: PageMeta | null;
}

interface RootState {
  loading: boolean;
  error: any;
}

export const pageMeta = {
  namespaced: true,

  // ✅ state как функция
  state(): PageMetaState {
    return {
      meta: null,
    };
  },

  mutations: {
    set(state: PageMetaState, payload: PageMeta | null) {
      state.meta = payload ?? null;
    },
    merge(state: PageMetaState, payload: Partial<PageMeta>) {
      state.meta = { ...(state.meta ?? {}), ...(payload ?? {}) };
    },
    clear(state: PageMetaState) {
      state.meta = null;
    },
  },

  actions: {
    set(
      { commit }: ActionContext<PageMetaState, RootState>,
      meta: PageMeta | null
    ) {
      commit("set", meta ?? null);
    },
    merge(
      { commit }: ActionContext<PageMetaState, RootState>,
      patch: Partial<PageMeta>
    ) {
      commit("merge", patch ?? {});
    },
    clear({ commit }: ActionContext<PageMetaState, RootState>) {
      commit("clear");
    },
  },
};
